module.exports = __webpack_public_path__ + "img/e42.0b04283d.png";